import type { LvMatch, PlanV3 } from "./types";

interface SetElementGroupLvMatchInPlanArgs {
  plan: PlanV3;
  elementGroupLabel: string;
  lvMatch: LvMatch;
}

export const setElementGroupLvMatchInPlan = ({
  plan,
  elementGroupLabel,
  lvMatch,
}: SetElementGroupLvMatchInPlanArgs): PlanV3 => {
  const existingMeta = plan.groupMeta[elementGroupLabel];
  if (!existingMeta) return plan;

  return {
    ...plan,
    groupMeta: {
      ...plan.groupMeta,
      [elementGroupLabel]: {
        ...existingMeta,
        lv_position: lvMatch.lvId,
        lvMatch,
      },
    },
  };
};
